import { render, staticRenderFns } from "./ExtraFieldsGroups.vue?vue&type=template&id=b9a02478&scoped=true&lang=pug"
import script from "./ExtraFieldsGroups.vue?vue&type=script&lang=js"
export * from "./ExtraFieldsGroups.vue?vue&type=script&lang=js"
import style0 from "./ExtraFieldsGroups.vue?vue&type=style&index=0&id=b9a02478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a02478",
  null
  
)

export default component.exports